export default __webpack_public_path__ + "0609dc7a5e2d434b80fc29b53e6963e8.png";